import { PAGES_METADATA_KEY } from "./pageMap";

/**
 * The metadata the document was imported with, such as a title or a volume: one line of names
 * and values above the text, under no heading (usability round 5: a "Metadata" block took about
 * 150 px for one volume field). Nothing when it has none. The page map is left out: each segment
 * shows its pages instead.
 */
export default function DocumentMetadata({ metadata }: { metadata: Readonly<Record<string, string>> }) {
  const entries = Object.entries(metadata).filter(([name]) => name !== PAGES_METADATA_KEY);

  if (entries.length === 0) {
    return null;
  }
  return (
    <dl className="flex flex-wrap gap-x-4 gap-y-1 px-4 text-sm sm:px-0">
      {entries.map(([name, value]) => (
        <div key={name} className="flex min-w-0 gap-1.5">
          <dt className="app-text-muted">{name}</dt>
          <dd className="min-w-0 [overflow-wrap:anywhere]">{value}</dd>
        </div>
      ))}
    </dl>
  );
}
